import { Modal } from 'antd'
import type { FtpCompareState } from './types'
import styles from './FtpClient.module.css'

interface FtpDiffModalProps {
  state: FtpCompareState | null
  loading: boolean
  onClose: () => void
}

export function FtpDiffModal({ state, loading, onClose }: FtpDiffModalProps) {
  return (
    <Modal
      title={
        state
          ? `Сравнение: ${state.name1} ↔ ${state.name2}`
          : 'Сравнение файлов'
      }
      open={!!state}
      onCancel={onClose}
      footer={null}
      width={960}
      destroyOnHidden
      styles={{ body: { maxHeight: '70vh', overflow: 'auto' } }}
    >
      {loading ? (
        <p>Загрузка…</p>
      ) : state ? (
        <div className={styles.diffWrap}>
          <div className={styles.diffPaths}>
            <span>{state.path1}</span>
            <span>{state.path2}</span>
          </div>
          <pre className={styles.diffPre}>
            {state.diff.map((chunk, i) => {
              const cls = chunk.added
                ? styles.diffAdded
                : chunk.removed
                  ? styles.diffRemoved
                  : styles.diffSame
              return (
                <span key={i} className={cls}>
                  {chunk.value}
                </span>
              )
            })}
          </pre>
        </div>
      ) : null}
    </Modal>
  )
}
